"use client"

import Link from "@/components/common/Link"
import { useAppSelector } from "@/hooks/redux"
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Col, Pagination, Row } from "antd"
import { useParams, usePathname } from "next/navigation"
import { ReactNode } from "react"

type CategoryProductsItemLoadMoreProps = {
  children: ReactNode,
  page: number
  pageSize: number
  total: number
}

const CategoryProductsItemLoadMore = (props: CategoryProductsItemLoadMoreProps) => {
  const filter = useAppSelector(state => state.product.product_list.filter)
  const pathname = usePathname()
  const params = useParams()

  return (
    <>
      {props.children}
      <Row justify="end" style={{ marginTop: '1.5rem' }}>
        <Col>
          <Pagination
            hideOnSinglePage
            total={props.total}
            current={props.page}
            pageSize={props.pageSize}
            showSizeChanger={false}
            onChange={(() => {})}
            itemRender={(page, type, defaultEle) => {
              const link = pathname.startsWith("/category")
                ? `/category/${params?.slug}/products/page/${page}`
                : `/products/page/${page}`

              switch (type) {
                case 'next':
                  return (
                    <Link
                      href={link}
                    >
                      <Button aria-label={`Go to next page ${page}`} htmlType="button" type="text" size="small">
                        <FontAwesomeIcon icon={faChevronRight} />
                      </Button>
                    </Link>
                  )

                case 'prev':
                  return (
                    <Link
                      legacyBehavior
                      href={link}
                    >
                      <Button aria-label={`Go to previous page ${page}`} htmlType="button" type="text" size="small">
                        <FontAwesomeIcon icon={faChevronLeft} />
                      </Button>
                    </Link>
                  )

                case "page":
                  return (
                    <Link
                      legacyBehavior
                      href={link}
                    >
                      {page}
                    </Link>
                  )
                default:
                  return defaultEle
              }
            }}
          />
        </Col>
      </Row>
    </>
  )
}

export default CategoryProductsItemLoadMore